"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapNamedRoutes = exports.routes = void 0;

var _internal = require("./internal");

// The first time the routes are loaded, iterate through them and create the named
// route functions.
let namedRoutes = {};
let namedRoutesDone = false;

const mapNamedRoutes = routes => {
  if (namedRoutesDone) {
    return namedRoutes;
  }

  for (let route of routes) {
    const {
      path,
      name,
      notfound
    } = route.props; // Skip the notfound route.

    if (notfound) {
      continue;
    } // Check for issues with the path.


    (0, _internal.validatePath)(path); // Create the named route function for this route.

    namedRoutes[name] = (args = {}) => (0, _internal.replaceParams)(path, args);
  } // Only need to do this once.


  namedRoutesDone = true;
  return namedRoutes;
};

exports.mapNamedRoutes = mapNamedRoutes;
const routes = namedRoutes;
exports.routes = routes;